import { createAction, props } from '@ngrx/store';
import { UserFilters } from '@shared/models/user-filters';

export const setUserFilters = createAction('[Users] Set User Filters', props<{ filters: UserFilters }>());
